const state = {
  confirmCancelNetwork: null,
  deleteIndexNetwork: null,
  deleteLabelNetwork: null,
  denyDeleteNetwork: false,
  formNetwork: { action: 'update', entry: null, scope: 'list' },
  isModalVisibleNetwork: false,
  isValidNetworkForm: false,
  promptDeleteNetwork: null,
}

export default state
